module.exports = __webpack_public_path__ + "static/media/banner1200.abd137fe.png";